import {
    POST_IMPORT_COST_PROVIDER_LOADING,
    POST_IMPORT_COST_PROVIDER_SUCCESS,
    POST_IMPORT_COST_PROVIDER_REJECT,
    POST_IMPORT_COST_PROVIDER_RESET,
} from "../../actions/importCostProvider/post";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    }
}

const importCostProviderReducer = (state = stateInit, action) => {
    switch (action.type) {

        // ------------- POST --------------------
        case POST_IMPORT_COST_PROVIDER_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_IMPORT_COST_PROVIDER_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_IMPORT_COST_PROVIDER_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_IMPORT_COST_PROVIDER_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        default: return state;
    }
}

export default importCostProviderReducer
